import React, { FC, useState, useEffect } from 'react';
import './style.scss';

interface Props {
  icon: string;
  styleDef?: React.CSSProperties;
  clickEvent: (e: React.MouseEvent) => void;
  status?: string;
  type?: string;
}

const IconButton: FC<Props> = ({ icon, clickEvent, styleDef, status, type }) => {
  return (
    <div className={['_icon_btn_box_div', type].join(' ')}>
      {status !== 'disable' ? (
        <button
          className={['_btn', status].join(' ')}
          onClick={e => clickEvent(e)}
          style={styleDef}
        >
          <i className={icon} />
        </button>
      ) : (
        <button className="_btn disable" style={styleDef}>
          <i className={icon} />
        </button>
      )}
    </div>
  );
};

export default IconButton;
